module.exports = {"cash_back":"Combine with<1 /><2> Cash Incentives</2> up to","rates":"Don't forget about<1 /> our <3> Rates </3> as low as"}